var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import parseHTML from "../dom/funciones/parse_html";
import { unaVez } from "../eventos";
var puntero = function () {
    unaVez(document.documentElement, 'mousemove', function (e) {
        var div = parseHTML('<div class="puntero"><i></i></div>');
        document.body.appendChild(div);
        var destino = { x: e.clientX, y: e.clientY }, actual = __assign({}, destino), hover = false;
        addEventListener('mousemove', function (e) {
            hover = e.target.closest('a,button:not([disabled]):not([aria-disabled="true"])') !== null;
            destino = { x: e.clientX, y: e.clientY };
        });
        var actualiza = function () {
            actual = {
                x: actual.x + (destino.x - actual.x) / 8,
                y: actual.y + (destino.y - actual.y) / 8
            };
            div.style.left = actual.x + 'px';
            div.style.top = actual.y + 'px';
            if (hover) {
                div.classList.add('hover');
            }
            else {
                div.classList.remove('hover');
            }
            requestAnimationFrame(actualiza);
        };
        actualiza();
    });
};
export default puntero;
